import { kpiValueColumnRender } from './customRender';

/**
 * 绩效指标表格静态列配置生成器
 * @param extraColumns
 * @returns {[{resizable: boolean, customRender: ((function({text: *, record: *}): string)|*), dataIndex: string[], width: number, title: string, align: string},{resizable: boolean, dataIndex: string[], width: number, title: string, align: string},...*[]]}
 */
export const useKpiTableStaticColumns = (extraColumns = []) => [
    {
        title: '指标值',
        field: 'value',
        dataIndex: [ 'data', 'value' ],
        width: 130,
        resizable: true,
        align: 'center',
        customRender: kpiValueColumnRender,
    },
    {
        title: '指标值说明',
        dataIndex: [ 'data', 'summary' ],
        field: 'summary',
        align: 'center',
        width: 260,
        resizable: true,
    },
    {
        title: '指标解释',
        dataIndex: [ 'data', 'explain' ],
        field: 'explain',
        align: 'center',
        width: 230,
        resizable: true,
    },
    {
        title: '绩效标准',
        dataIndex: [ 'data', 'std' ],
        field: 'std',
        align: 'center',
        width: 180,
        resizable: true,
    },
    {
        title: '指标依据',
        dataIndex: [ 'data', 'basis' ],
        field: 'basis',
        align: 'center',
        width: 180,
        resizable: true,
    },
    {
        title: '评分标准',
        dataIndex: [ 'data', 'scoreStd' ],
        field: 'scoreStd',
        align: 'center',
        width: 180,
        resizable: true,
    },
    ...extraColumns,
];
